module.exports = __webpack_public_path__ + "img/kobido.d5ec7080.jpg";